import PropTypes from "prop-types";
import { getReturnSteps, getReturnProgress, getStatusNote } from "./refundFlow";

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="m5 12.5 4.5 4.5L19 7.5"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const STEP_ICONS = {
  submitted: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M7 4h7l4 4v12H7zM14 4v4h4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  ),
  review: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="m15.5 15.5 4 4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  ),
  decision: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 4v16M6 8h9a2.5 2.5 0 0 1 0 5H8a2.5 2.5 0 0 0 0 5h10"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

/*
 * Horizontal on desktop, vertical on narrow screens — the switch is in CSS
 * so the markup stays a single tree for both.
 */
const ReturnStepper = ({ status }) => {
  const steps = getReturnSteps(status);
  const percent = getReturnProgress(status);
  const currentLabel = steps.find((step) => step.current)?.label || "Submitted";

  return (
    <section className="c4rtn__card" aria-labelledby="c4rtn-progress-heading">
      <h2 className="c4rtn__card-title" id="c4rtn-progress-heading">
        Return Progress
      </h2>

      <p className="c4rtn__sr-status" role="status">
        Current stage: {currentLabel}
      </p>

      <ol className="c4rtn__steps">
        <span className="c4rtn__rail" aria-hidden="true">
          <span
            className="c4rtn__rail-fill"
            style={{ "--c4rtn-progress": `${percent}%` }}
          />
        </span>

        {steps.map((step) => {
          const state = step.current ? "current" : step.pending ? "pending" : "done";

          return (
            <li
              className={`c4rtn__step c4rtn__step--${state}`}
              key={step.key}
              aria-current={step.current ? "step" : undefined}
            >
              <span className="c4rtn__dot" aria-hidden="true">
                {state === "done" ? <CheckIcon /> : STEP_ICONS[step.key]}
              </span>
              <span className="c4rtn__step-body">
                <span className="c4rtn__step-label">{step.label}</span>
                <span className="c4rtn__step-hint">{step.hint}</span>
              </span>
            </li>
          );
        })}
      </ol>

      <p className="c4rtn__note">{getStatusNote(status)}</p>
    </section>
  );
};

ReturnStepper.propTypes = {
  status: PropTypes.string,
};

export default ReturnStepper;
